import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import TripFeedbackTable from '../../components/trip-feedbacks/TripFeedbackTable'
import { getManyFeedbacks, actionCreators, updateFeedbackStatus } from '../../state/actions/trips/index'
import { ITripFilters } from '../../types'
const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const organizations = state.organizations.currentOrgId
    ? state.organizations.items[state.organizations.currentOrgId]
    : null
  return {
    routeProps: ownProps,
    orgId: state.organizations.currentOrgId,
    filters: state.trips.filters,
    services: Object.values(state.service.items),
    organizations
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchFeedbacks: (params: ITripFilters) => dispatch(getManyFeedbacks(params)),
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.updateTripFilters(params)),
    updateFeedbackStatus: (tripId: string, feedbackStatus: string, prevFeedbackStatus: string) =>
      dispatch(updateFeedbackStatus(tripId, feedbackStatus, prevFeedbackStatus))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripFeedbackTable)



// WEBPACK FOOTER //
// ./src/containers/trip-feedbacks/TripFeedbackTable.ts